var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sidebar" }, [
    _c("nav", { staticClass: "sidebar-nav" }, [
      _c("div", { attrs: { slot: "header" }, slot: "header" }),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "nav" },
        _vm._l(_vm.listSideBar, function(item, index) {
          return _c(
            "li",
            { staticClass: "nav-item" },
            [
              [
                _c("SidebarNavIcons", {
                  attrs: {
                    name: item.name,
                    routerName: item.routerName,
                    icon: item.icon
                  }
                })
              ]
            ],
            2
          )
        })
      ),
      _vm._v(" "),
      _c("div", { attrs: { slot: "footer" }, slot: "footer" })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5740e3c6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5740e3c6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eventManagement/sidebar/Sidebar.vue
// module id = 1822
// module chunks = 1